class TabbedContent extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');

      this.bindEvents();
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick.bind(this));
      });
    }

    onTabClick(event) {
      const selectedTab = event.currentTarget;
      const selectedPanel = this.panels[selectedTab.dataset.tabIndex];

      this.setActiveTab(selectedTab);
      this.setActivePanel(selectedPanel);
    }

    setActiveTab(tab) {
      this.tabs.forEach((t) => {
        t.setAttribute('aria-selected', t === tab);
        t.classList.toggle('active', t === tab);
      });
    }

    setActivePanel(panel) {
      this.panels.forEach((p) => {
        p.hidden = p !== panel;
      });
    }
  }

customElements.define('tabbed-content', TabbedContent);